import React from 'react'
import { connect } from 'react-redux'
import Partners from '../components/partners'

const mapStateToProps = (state) => ({
  ...state.partners
})

const mapDispatchToProps = dispatch => ({
  onCreate: payload => dispatch({type: 'PARTNERS.CREATE', payload}),
  onUpdate: payload => dispatch({type: 'PARTNERS.UPDATE', payload}),
  onDelete: payload => dispatch({type: 'PARTNERS.DELETE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Partners)
